import React from 'react';
import './Stylebox.css'; // Updated CSS is assumed

const styleCategories = [
  { label: 'Large<br>Growth', value: 'large_growth' },
  { label: 'Large<br>Blend', value: 'large_blend' },
  { label: 'Large<br>Value', value: 'large_value' },
  { label: 'Mid Growth', value: 'mid_growth' },
  { label: 'Mid Blend', value: 'mid_blend' },
  { label: 'Mid Value', value: 'mid_value' },
  { label: 'Small Growth', value: 'small_growth' },
  { label: 'Small Blend', value: 'small_blend' },
  { label: 'Small Value', value: 'small_value' },
];

/**
 *
 * @param onSubmit {Function} - Callback function to handle the selected style as a string
 * @returns {JSX.Element}
 * @constructor
 */
const StyleBox = ({ onSubmit }) => {

  const handleSubmit = (selectedStyle) => {
    onSubmit(selectedStyle);
  };

  return (
    <div className="styleBoxContainer pb-3" style={{background: 'transparent'}}>
      <div className="grid">
        {styleCategories.map(style => (
          <div
            key={style.value}
            className={'cell'}
            onClick={() => handleSubmit(style.value)}
          >
            {style.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StyleBox;
